import { Component } from '../core/component';

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

export class Global extends Component {
    constructor() {
        super();
        this.selector = '[data-main]';
    }

    init() {
        // lazySizes.init();
    }
}
